export const CicFeeChangeColumnId = {
  FEE: 'fee',
  CHANGE: 'change',
  REASON: 'reason',
  COMMENT: 'comment',
  ENTERED_BY: 'enteredBy',
  ACTIONS: 'actions',
};
